import React from "react";
import allImgPaths from "assets/images";

interface PatentResult {
  number: string;
  verified?: boolean;
}

interface PatentVerificationResultsProps {
  results: PatentResult[];
  processingPatents: boolean;
  processingComplete: boolean;
}

const PatentVerificationResults: React.FC<PatentVerificationResultsProps> = ({
  results,
  processingPatents,
  processingComplete,
}) => {
  if (results.length === 0) return null;

  return (
    <div className="mt-4">
      <div className="overflow-y-auto max-h-[calc(100vh_-_440px)] pr-1.5">
        {results.map((patent, index) => (
          <div
            key={patent.number + index}
            className="rounded-md p-2.5 mb-2 last:mb-0 border border-[#E6E6E6]"
          >
            <div className="flex items-start justify-between">
              <div className="flex items-start gap-x-3 w-full">
                <img src={allImgPaths.pdfIcon} alt="" />
                <div className="w-full">
                  <div className="flex items-center justify-between w-full">
                    <p
                      title={patent.number}
                      className="font-interMedium text-[#0A090B] text-sm pb-1 truncate max-w-96"
                    >
                      {patent.number}
                    </p>
                  </div>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-x-2">
                      {processingPatents && patent.verified === true && (
                        <span className="flex items-center text-[#4F4D55] font-interRegular text-sm gap-x-1">
                          <div className="w-3 h-3 border-2 border-[#1751D0] border-t-transparent rounded-full animate-spin"></div>
                          Uploading...
                        </span>
                      )}
                      {processingComplete && patent.verified === true && (
                        <span className="flex items-center text-[#4F4D55] font-interRegular text-sm gap-x-1">
                          <img src={allImgPaths.greenCheckIcon} alt="" />
                          Uploaded
                        </span>
                      )}
                    </div>
                    {patent.verified === true && (
                      <span className="flex items-center justify-between text-[#4F4D55] font-interRegular text-sm gap-x-1">
                        <img src={allImgPaths.greenCheckIcon} alt="" />
                        Verified
                      </span>
                    )}
                    {patent.verified === false && (
                      <span className="flex items-center justify-between text-[#E53535] font-interRegular text-sm gap-x-1">
                        <img src={allImgPaths.errorIcon2} alt="" />
                        Verification Failed
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PatentVerificationResults;
